import { Box, Link as MuiLink, Typography } from "@mui/material";

/**
 * Wrapper cinza + breadcrumb clicável — cópia literal da Box de DetalheIcms (que por sua
 * vez replica a tela de Usuários), usada pelas telas de Lançamentos/Detalhes (drill-down de
 * uma aba) para que o card branco renderize na MESMA largura/moldura das abas. Antes, essas
 * telas usavam styles.pageWrap/.container (Detalhe/detalhe.styles.module.css) — padding e
 * box-shadow diferentes, resultando num card mais estreito/com moldura própria — e um botão
 * "← Voltar" simples em vez do breadcrumb clicável (Apurações › Apuração X › Lançamentos Y)
 * que o resto do sistema usa.
 *
 * `itens`: array de { label, onClick? }. Sem `onClick` = página atual (texto, não link) —
 * normalmente só o último item.
 */
export default function BreadcrumbApuracao({ itens, children }) {
  return (
    <Box
      sx={{
        margin: "0 2rem",
        maxWidth: "100%",
        bgcolor: "#f5f7fa",
        borderRadius: "12px",
        p: 2,
        minHeight: "100%",
        "@media (max-width: 780px)": { margin: "0 1rem", p: 2 },
      }}
    >
      <Box sx={{ bgcolor: "#f5f7fa", borderRadius: "12px", overflow: "visible", mb: 2 }}>
        <Box sx={{ bgcolor: "#ffffff", border: "1px solid #e0e0e0", borderRadius: "12px", px: 3, py: 1.25, mb: 2, display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
          {itens.map((item, i) => (
            <Box key={i} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              {i > 0 && <Typography sx={{ fontSize: 13, color: "#9aa0a6", mx: 0.25 }}>›</Typography>}
              {item.onClick ? (
                <MuiLink
                  component="button"
                  type="button"
                  onClick={item.onClick}
                  underline="hover"
                  sx={{ fontSize: 13, color: "#1a73e8", fontWeight: 400, cursor: "pointer", background: "none", border: "none", p: 0 }}
                >
                  {item.label}
                </MuiLink>
              ) : (
                <Typography sx={{ fontSize: 13, color: "#5f6368" }}>{item.label}</Typography>
              )}
            </Box>
          ))}
        </Box>

        {children}
      </Box>
    </Box>
  );
}
